import { type TFunction } from 'i18next';

import { categoryGroups } from '@cx-modules/constants';

export const getMarketLabel = ({ marketName, t }: { marketName: string; t: TFunction }) => {
  const marketNameKeyified = normaliseLabelKey(marketName);
  const labelKey = `CX_MARKET_TYPE_${marketNameKeyified}`;
  const labelValue = t(labelKey, { ns: 'label' });

  // if no label exists for the requested key, the key will be returned. Check and return the untranslated market name in this case.
  return labelValue === labelKey ? marketName : labelValue;
};

export const categoryIdToCategoryMap = categoryGroups.reduce<Record<number, string>>((acc, group) => {
  if (group.translationFile) {
    acc[group.id] = group.translationFile;
  }

  return acc;
}, {});

export const normaliseLabelKey = (str: string) =>
  str
    .replace(/[ /-]+/g, '_')
    .replace(/[^a-zA-Z0-9_]/g, '')
    .replace(/_+/g, '_')
    .toUpperCase();

export const getTranslatedBetTitle = ({
  betName,
  lineName,
  ns,
  t,
}: {
  betName: string;
  lineName: string;
  ns: string | string[];
  t: TFunction;
}) => {
  const betTitle = `${betName} ${lineName || ''}`.trim();

  if (betTitle.toLowerCase() === 'draw') {
    let attempt = t('Draw', { defaultValue: 'NOT_FOUND', ns });

    if (attempt === 'NOT_FOUND') {
      attempt = t('DRAW', { ns });
    }

    return attempt;
  }

  const labelKey = betName;

  const translatedBetName = t(labelKey, { ns });

  if (betName && lineName === betName) {
    return `${translatedBetName}`.trim();
  }
  return `${translatedBetName} ${lineName || ''}`.trim();
};
